import { configureStore } from '@reduxjs/toolkit'
import { isDevelopment } from '@/utils/environment'
import authReducer from '../features/auth/authSlice'
import activitiesRecuder from '../features/activities/activitiesSlice'
import contactsReducer from '../features/contacts/contactsSlice'
import biensReducer from '../features/biens/biensSlice'
import visitesReducer from '../features/visites/visitesSlice'
import locationsReducer from '../features/locations/locationsSlice'
import mandatsReducer from '../features/mandats/mandatsSlice'
import entretiensSlice from '../features/entretiens/entretiensSlice'
import interventionsReducer from '../features/interventions/interventionsSlice'
import historiqueReducer from '../features/historique/historiqueSlice'
import documentsReducer from '../features/documents/documentsSlice'
import prestatairesReducer from '../features/prestataires/prestatairesSlice'
import quittancesReducer from '../features/quittances/quittancesSlice'
import flashMessagesReducer from '../features/flash/flashMessagesSlice'
import themeReducer from '../features/theme/themeSlice'
import processTasksReducer from '../features/process-tasks/processTasksSlice'
import macroProcessesReducer from '../features/process-tasks/macroProcessesSlice'
import renewTasksReducer from '../features/renew-tasks/renewTasksSlice'
import macroProcessCreationReducer from '../features/macro-process-creation/macroProcessCreationSlice'
import macroProcessEditReducer from '../features/macro-process-edit/macroProcessEditSlice'
// import { persistAuthMiddleware } from './middlewares/localStorage'
// import { debugMiddleware } from './middlewares/debugMiddleware'

// Importez l'espion Redux
import { startReduxSpy, stopReduxSpy } from '../utils/debug/reduxSpy'

// Ajouter un bouton/méthode pour activer l'espionnage
export const activateReduxSpy = () => {
  startReduxSpy(store);
};

export const deactivateReduxSpy = () => {
  stopReduxSpy(store);
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    activities: activitiesRecuder,
    biens: biensReducer,
    contacts: contactsReducer,
    documents: documentsReducer,
    entretiens: entretiensSlice,
    interventions: interventionsReducer,
    historique: historiqueReducer,
    locations: locationsReducer,
    mandats: mandatsReducer,
    prestataires: prestatairesReducer,
    quittances: quittancesReducer,
    visites: visitesReducer,
    flash: flashMessagesReducer,
    theme: themeReducer,
    processTasks: processTasksReducer,
    renewTasks: renewTasksReducer,
    macroProcessCreation: macroProcessCreationReducer,
    macroProcesses: macroProcessesReducer,
    macroProcessEdit: macroProcessEditReducer
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      // Ajouter des options de configuration pour voir si elles affectent le comportement
      //serializableCheck: false, // Désactiver temporairement les vérifications de sérialisation
      //immutableCheck: false,    // Désactiver temporairement les vérifications d'immutabilité
      thunk: {
        extraArgument: {
          debug: isDevelopment()  // Ajouter un flag de débogage pour voir s'il y a des effets secondaires
        }
      }
    })
    // .concat(debugMiddleware)
    // .concat(persistAuthMiddleware)
});